import { render, staticRenderFns } from "./WidthProperty.vue?vue&type=template&id=af1e8370&"
import script from "./WidthProperty.vue?vue&type=script&lang=js&"
export * from "./WidthProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports